import { render, staticRenderFns } from "./LogoBar.vue?vue&type=template&id=4d96f284&scoped=true&"
import script from "./LogoBar.vue?vue&type=script&lang=js&"
export * from "./LogoBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d96f284",
  null
  
)

export default component.exports